import { ChangeEventHandler } from 'react';
import { Button, FormLabel, Group, IconCrossCircle, Input } from '@screentone/core';

import { RIBBON_REGEX } from 'utils/constants';
import styles from '../PageModule.module.scss';

interface RibbonProps {
  url: string;
  error: boolean;
  setError: (error: boolean) => void;
  onChange: (url: string) => void;
  disabled?: boolean;
}

const Ribbon = ({ url, error, setError, onChange, disabled = false }: RibbonProps) => {
  const handleInputValueChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;

    setError(value !== '' && !RIBBON_REGEX.test(value));
    onChange(value);
  };

  const handleClearField = () => {
    setError(false);
    onChange('');
  };

  return (
    <>
      <FormLabel key="ribbonUrl" label="Ribbon" fullWidth margin={{ top: 'sm' }} />
      <Group gap="xs" className={styles.inputContainer}>
        <Input
          placeholder="Add a ribbon .json URL"
          value={url}
          margin={{ bottom: 'sm' }}
          onChange={handleInputValueChange}
          data-testid="ribbon"
          error={error}
          disabled={disabled}
        />
        {!disabled && (
          <Button tertiary icon={IconCrossCircle} className={styles.deleteIcon} onClick={handleClearField} />
        )}
      </Group>
    </>
  );
};

export default Ribbon;
